import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark,
    faBars,
} from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import LanguageSelectionButtons from './LanguageSelectionButtons';

const HeaderBlock = styled.div`
    position: sticky;
    top: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: #fff;
    box-shadow: 0 2px 2px ${palette.gray[4]};
`;

const NavBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5rem;
    max-width: 1280px;
    margin: 0 auto;

`;

const Logo = styled(Link)`
    flex-basis: 20%;
    font-style: italic;
    font-weight: 700;
    .big-letter {
        font-size: 1.75rem;
        color: ${palette.yachtBlue};         // yacht blue
    }
    .small-letter {
        font-size: 1.25rem;
        margin-left: 0.3rem;
        color: ${palette.orange};         // Orange
    }
`;

// const Nav = styled.div`
//     // 외부 정렬
//     flex-basis: 65%;
//     // 내부 정렬
//     display: flex;
//     // 뷰포트
//     @media (max-width: 980px) {
//         display: none;
//     }
// `;

const StyledLink = styled(Link)`
    color: ${palette.gray[8]};
    font-size: 1.125rem;
    font-weight: 500;
    & + & {
        margin-left: 1rem;
    }
    &:hover {
        color: ${palette.gray[6]};
    }
    // 애니메이션
    transition: 0.3s;
`;

const ProjectTitle = styled.div`
    flex: 1;
    margin-left: 1rem;
    font-weight: 500;
`;

const Div = styled.div`
    flex-basis: 15%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    // 속성

    // 뷰포트
    @media (max-width: 980px) {
        display: none;
    }
`;

const StyledButton = styled.button`
    // 외부 정렬
    width: 100%;
    max-width: 80px;
    // 내부 정렬
    display: flex;
    justify-content: space-around;
    align-items: center;
    // height: 100%;
    height: 40px;
    border: none;
    background-color: ${palette.yachtBlue};
    color: #fff;
    font-size: 0.95rem;
    font-weight: 500;
    &:hover {
        border: 0.5px solid ${palette.yachtBlue};
        background-color: #fff;
        color: ${palette.yachtBlue};
        cursor: pointer;
    }
    // 애니메이션
    transition: 0.3s;
`;

const ToggleButton = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: ${palette.yachtBlue};
    font-size: 2rem;
    cursor: pointer;
`;

const DropDownMenu = styled.div`
    position: absolute;
    top: 5rem;
    right: 2rem;
    width: 200px;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(15px);
    border-radius: 10px;
    li + li {
        margin-top: 1rem;
    }
    .btn-area {
        display: flex;
    }
`;

const UserInfo = styled.div`
    font-weight: 500;
    margin-right: 1rem;
    font-size: 1rem;
    color: ${palette.yachtBlue};
`;

const Header = ({ user, project, language, onChangeLanguage, onLogout }) => {
    const [isOpen, setIsOpen] = useState(false);

    const isDesktop = useMediaQuery({ query: '(min-width: 980px)' });

    return (
        <HeaderBlock>
            <NavBar>
                <Logo to="/">
                    <span className="big-letter">MMM</span><span className="small-letter">Engineering</span>
                    {/* <span className="big-letter">WebCraft</span><span className="small-letter">Solutions</span> */}
                    {/* <span className="big-letter">IL</span><span className="small-letter">Soft & Engineering</span> */}
                </Logo>
                <ProjectTitle>
                    {project && (
                        <>
                            {project.title} / {project.user.username}
                        </>
                    )}
                </ProjectTitle>
                <LanguageSelectionButtons language={language} onChangeLanguage={onChangeLanguage} />
                <Div>
                    {user && (
                        <>
                            <UserInfo>{user.username}</UserInfo>
                            <StyledButton onClick={onLogout}>
                                Logout
                            </StyledButton>
                        </>
                    )}
                    {!user && (
                        <>
                            <StyledLink to="/login">
                                <StyledButton>Login</StyledButton>
                            </StyledLink>
                            <StyledLink to="/register">
                                <StyledButton>Register</StyledButton>
                            </StyledLink>
                        </>
                    )}
                </Div>
                {/* Dropdown 메뉴 */}
                {!isDesktop && (
                    <ToggleButton>
                        {user && <UserInfo>{user.username}</UserInfo>}
                        <FontAwesomeIcon
                            onClick={() => setIsOpen(!isOpen)}
                            icon={isOpen ? faXmark : faBars}
                        />
                    </ToggleButton>
                )}
            </NavBar>

            {/* Dropdown 메뉴 */}
            {isOpen && !isDesktop && (
                <DropDownMenu>
                    {/* 여백을 주기 위해 */}
                    <div style={{ marginBottom: '1.25rem' }}></div>
                    {/* 여백을 주기 위해 */}
                    <div className="btn-area">
                        {user && (
                            <>
                                {/* <UserInfo>{user.username}</UserInfo> */}
                                <StyledButton onClick={onLogout}>
                                    Logout
                                </StyledButton>
                            </>
                        )}
                        {!user && (
                            <>
                                <StyledLink to="/login">
                                    <StyledButton>Login</StyledButton>
                                </StyledLink>
                                <StyledLink to="/register">
                                    <StyledButton>Register</StyledButton>
                                </StyledLink>
                            </>
                        )}
                    </div>
                </DropDownMenu>
            )}
            {/* Dropdown 메뉴 */}
        </HeaderBlock>
    );
};

export default Header;
